module.exports = __webpack_public_path__ + "img/2.fa7388f0.png";